const $ = require("jquery");
require("slick-carousel");

/**
 * Reviews carousel for the shared reviews block.
 * Markup: templates/public/static/components/partials/reviews-block--embed.html.twig
 *
 * Require this from a page JS entry:
 *   require("../../components/ui-components/reviewsCarousel");
 * It self-initialises on DOM ready and does nothing when the block is absent,
 * so it is safe to require from an entry shared by several pages.
 *
 * The prev/next labels are read from the markup so they stay translated.
 */
function initReviewsCarousel() {
    const $slider = $(".reviews-block__slider");
    if (!$slider.length) {
        return;
    }

    const $nav = $(".reviews-block__nav");
    const prevLabel = $nav.data("prev-label") || "Previous";
    const nextLabel = $nav.data("next-label") || "Next";
    const arrowSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M12 5l7 7-7 7"/></svg>';

    $slider.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        speed: 300,
        dots: false,
        arrows: true,
        appendArrows: $nav.length ? $nav : $slider,
        prevArrow: '<button type="button" class="reviews-block__arrow reviews-block__arrow--prev" aria-label="' + prevLabel + '">' + arrowSvg + '</button>',
        nextArrow: '<button type="button" class="reviews-block__arrow reviews-block__arrow--next" aria-label="' + nextLabel + '">' + arrowSvg + '</button>',
        responsive: [
            { breakpoint: 1200, settings: { slidesToShow: 2 } },
            { breakpoint: 768, settings: { slidesToShow: 1 } }
        ]
    });
}

$(function () {
    initReviewsCarousel();
});

module.exports = { initReviewsCarousel };
